/**
 * Variant Utilities
 * 
 * Core utilities for variant support that are shared across the codebase.
 * These are pure functions with no UI dependencies.
 */

import type { VariantDraft } from './types';

/**
 * Map variant draft to Item attributes child table format
 * 
 * Converts VariantDraft to the format expected by Frappe Item doctype
 * attributes child table.
 * 
 * For template items, we only store the attribute names (not values).
 * Values are stored per variant when variants are created.
 * 
 * Performance: O(n) where n = number of attributes
 */
export function variantDraftToItemAttributesRows(
  draft: VariantDraft
): Array<{ attribute: string; attribute_value?: string }> {
  if (draft.mode !== 'item_attribute') {
    return [];
  }

  // For template items: store which attributes define variants.
  // Do NOT send attribute_value at all (avoid empty-string mandatory validation issues).
  return draft.attributes.map((attr) => ({
    attribute: attr.attribute,
  }));
}
